import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BbitString } from '@bbitgmbh/bbit.utils';
import { BbitWebShopAlgoliaService, BbitWebShopService } from '@bbitgmbh/webshop.sdk';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  private _webShop = inject(BbitWebShopService);
  private _algolia = inject(BbitWebShopAlgoliaService);
  private _location = inject(Location);
  private _router = inject(Router);

  private _initialCall = true;
  constructor() {
    const allCategories = this._webShop.getCategories();
    this._algolia.observeCategoryFilters().subscribe((filters) => {
      const slugs = [];
      if (filters.length > 0) {
        const currentCategoryFilter = filters[filters.length - 1].split(':')[1];
        const currentCategoryArr = currentCategoryFilter.split(' > ');
        const categoryIds = currentCategoryArr.map((o) => BbitString.ensureBeginningHashtag(o));
        for (const categoryId of categoryIds) {
          const found = allCategories.find((o) => BbitString.ensureBeginningHashtag(o._id) === categoryId);
          slugs.push(found?._slug);
        }
      }

      const replaceUrlParam = (param: string, value?: string) => {
        const params = new URLSearchParams(window.location.search);
        if (value) {
          params.set(param, value);
        } else {
          if (!this._initialCall) {
            params.delete(param);
          }
          this._initialCall = false;
        }
        const paramsString = params.toString();
        const newPath = window.location.pathname + (paramsString ? `?${paramsString}` : '');
        this._location.replaceState(newPath);
      };

      replaceUrlParam('c', slugs.join('>'));
    });
  }
}
